import { createTestId } from 'utils';
import React, { Fragment, useContext, useState } from 'react'
import { Menu, Transition } from "@headlessui/react";
import * as Icon from "react-feather"
import { useSelector } from 'react-redux';
import { AppContext } from 'configuration/app-context';
import * as Redux from "utils/redux-store"
import { useCookies } from 'react-cookie';
import WebClient from 'utils/webclient';
import { BasketService } from 'utils/api-service';
import { useLocation, useNavigate } from 'react-router-dom';
import { publish } from 'utils/global-events';
import { ThemeContext } from 'configuration/theme-context';
import classNames from 'classnames'

const ProfileDropDown = () => {

    const [cookies, setCookie, removeCookie] = useCookies(["member", "patient"])
    const patient = useSelector(state => state.patient)
    const isLoyaltyMember = patient?.isLoyaltyMember
    const loyaltyUsabilityStatus = patient?.loyaltyUsabilityStatus
    const patientMembership = useSelector(state => state.patientMembership)
    const member = useSelector(state => state.member)
    const languageId = useSelector(state => state.languageId)
    const { translate, showDialog } = useContext(AppContext)
    const { theme } = useContext(ThemeContext)
    const navigate = useNavigate()
    const location = useLocation()

    const [isClickable, setIsClickable] = useState(true)

    const navigation = [
        {
            id: "profile",
            title: "profile",
            icon: <Icon.User size={16} />,
            navLink: "/profile",
        },
        {
            id: "kocHealthClub",
            title: "menu_koc_health_club",
            icon: <Icon.Star size={16} />,
            navLink: "/membership",
            show: isLoyaltyMember && loyaltyUsabilityStatus
        }
    ]

    const PatientDetail = (profile) => {
        let c = new WebClient();
        c.post("443376B83AD660/Detail", {
            profile: {
                guid: profile.guid,
                sessionId: profile.sessionId,
                patientId: profile.patientId,
                profileId: profile.profileId,
                languageId: languageId,
                userId: profile.userId
            },
            data: 0
        })
            .then(({ isSuccess, exception, data }) => {
                if (isSuccess) {
                setCookie("member", profile, {expires: 0})
                setCookie("patient", data, {expires: 0})                
                    Redux.setPatientData(data)
                    Redux.setMemberData(profile)
                    new BasketService().getBasketCount()
                    showDialog(
                        translate("successful"),
                        translate("successful_change_profile"),
                        "success",
                        false,
                        translate("ok"),
                        () => { Redirect() },
                        () => { Redirect() }
                    )
                }
            })
    }

    // CHANGE PROFİLE DE PATİENTCARDINFORMATİON ????

    const Redirect = () => {
        if (location.pathname == "/") {
            publish("onDashboardRefresh")
        } else {
            navigate("/")
        }
    }

    const ChangeProfile = (profileId) => {
        let c = new WebClient();
        c.post("443376B83AD660/ChangeProfile", profileId, true)
            .then(({ isSuccess, exception, data }) => {
                if (isSuccess) {
                    PatientDetail(data)
                }
            })
    }


    return (
        <Menu>
            {({ open }) => (
                <>
                    <Menu.Button className="nav-link nav-user gap-2 items-center">
                        <div 
                            className="user-avatar-wrapper" 
                            style={{
                                backgroundImage: isLoyaltyMember
                                ? `${patientMembership?.styles?.bgGradientRight}`
                                : "none"
                            }}>
                            <div 
                                className="user-avatar" 
                                style={{
                                    backgroundImage: isLoyaltyMember
                                    ? `${patientMembership?.styles?.bgGradientBottom}`
                                    : "none"
                                }}>
                                {
                                    patient?.photo ?
                                        <img src={patient.photo} style={{ width: "100%", height: "auto" }} alt="" className='w-full'/>
                                        :
                                        <Icon.User className={classNames("w-5 h-5", {
                                            "text-white" : isLoyaltyMember
                                        })}/>
                                }
                            </div>
                        </div>
                        <div className="user-info text-left hidden lg:block text-sm font-medium">
                            <h3 className="user-info_name">{patient.name} {patient.surname}</h3>
                            {
                                isLoyaltyMember && (
                                    <div className="user-info_label tracking-wider" style={{ color: patientMembership?.styles?.color}}>{patientMembership?.cardTypeName}</div>
                                )
                            }
                        </div>
                        <Icon.ChevronDown size={16}  className="hidden xs:block"/>
                    </Menu.Button>

                    {
                        theme != "theme-codeLotus" && (
                            <Transition
                                as={Fragment}
                                show={open}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                            >
                                <Menu.Items
                                    static
                                    className="dropdown-menu mt-2"
                                >
                                    {navigation.map((item, key) => 
                                        item.show == false ? null
                                        : (
                                            <Menu.Item
                                                as="button"
                                                key={item.id}
                                                className="dropdown-item"
                                                data-testid={createTestId('menu', 'ProfileDropDown', key)} onClick={() => navigate(item.navLink)}
                                            >
                                                {item.icon}
                                                {translate(item.title)}
                                            </Menu.Item>
                                         )
                                )}
        
                                    <Menu.Item as="hr" />
                                            <Menu.Item
                                                as="button"
                                                className="dropdown-item"
                                                data-testid={createTestId('menu', 'ProfileDropDown', navigation.length + 1)} 
                                                disabled={!isClickable}
                                                onClick={() => {
                                                    setIsClickable(false)
                                                    Redux.logout() 
                                                }}
                                            >
                                        <Icon.LogOut size={16}/>
                                        {translate("logout")}
                                            </Menu.Item>
        
                                    {
                                    member.patientId != member.profileId && (
                                    <Menu.Item
                                        as="button"
                                        className="dropdown-item"
                                        data-testid={createTestId('menu', 'ProfileDropDown', navigation.length + 2)} onClick={() => {
                                            ChangeProfile(0)
                                        }}
                                    >
                                        <Icon.RefreshCcw size={16}/>
                                                {translate("back_main_profile")}
                                    </Menu.Item>
                                    )
                                    }
        
                                </Menu.Items>
                            </Transition>
                        )
                    }

                </>
            )}
        </Menu>
    );
}

export default ProfileDropDown